// Mağaza modülü ortak yardımcıları
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d[0]?.msg?.replace('Value error, ', '') || 'İşlem başarısız';
  return 'İşlem başarısız';
};
export const KVKK = {
  yok: ['Yüklenmedi', 'bg-slate-100 text-slate-600'],
  beklemede: ['Onay Bekliyor', 'bg-amber-100 text-amber-800'],
  onay: ['Onaylı', 'bg-emerald-100 text-emerald-700'],
  eksik: ['Reddedildi', 'bg-rose-100 text-rose-700'],
};
export const dt = (s) => (s ? new Date(s).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '');
